import { isEmpty } from 'lodash';
import { getInitialPaymentsFormData } from 'src/components/Insurance/utils/';
import getInitialValuesFromContact from './getInitialValuesFromContact';
import defaultPhoneNumber from './defaultPhoneNumber';
import defaultEmailAddress from './defaultEmailAddress';
import defaultAddress from './defaultAddress';

const initialPhoneNumber = defaultPhoneNumber(true);
const initialEmail = defaultEmailAddress(true);
const initialAddress = defaultAddress({ is_primary: true });

/**
 * Selects the appropriate contact object for generating initial values.
 * Prefers the fetched `contact` over `selectedContact`.
 */
export const getContactForInitialValues = (contact, selectedContact) => (
  !isEmpty(contact) ? contact : selectedContact
);

const DEFAULT_FORM_VALUES = {
  gender: 'undisclosed',
  marital_status: 'undisclosed',
  race: 'undisclosed',
  ethnicity: 'undisclosed',
  sexuality: [],
  phone_numbers: [initialPhoneNumber],
  email_addresses: [initialEmail],
  addresses: [initialAddress],
};

/**
 * Builds the merged initial values for the contact information form.
 * Combines default values, decoded contact data, selected contact data,
 * and payment/insurance data using a last-write-wins merge strategy.
 *
 * @param {Object} params
 * @param {Object} params.contact - Fetched contact from the store
 * @param {Object} params.selectedContact - Pre-selected contact from search
 * @param {Object} params.contactData - Decoded contact data from URL params
 * @param {Array}  params.insurances - Insurance records for the contact
 * @returns {Object} Merged initial values for React Final Form
 */
export default function buildContactInitialValues({
  contact,
  selectedContact,
  contactData,
  insurances,
}) {
  const contactForInitialValues = getContactForInitialValues(contact, selectedContact);
  const selectedContactData = getInitialValuesFromContact(contactForInitialValues || {}) || {};
  const decodedContactData = getInitialValuesFromContact(contactData) || {};
  const paymentData = getInitialPaymentsFormData(insurances || []) || {};

  return {
    ...DEFAULT_FORM_VALUES,
    ...decodedContactData,
    ...selectedContactData,
    ...paymentData,
  };
}
